import { Redirect, Route, Switch } from "react-router-dom";
import "./Account.scss";
import ManageSubscriptions from "./manageSubscriptions/ManageSubscriptions";
import Payment from "./payment/Payment";
import Profile from "./profile/Profile";
import AccountTabs from "./_root/components/AccountTabs";
import Integrations from "./integrations/Integrations";

export default function Account() {
  return (
    <div id="account-page">
      <AccountTabs />
      <div data-testid="account-content">
        <Switch>
          <Route exact path="/account">
            <Redirect to="/account/profile" />
          </Route>
          <Route path="/account/profile">
            <Profile />
          </Route>
          <Route path="/account/manage-subscriptions">
            <ManageSubscriptions />
          </Route>
          <Route exact path="/account/payment">
            <Payment />
          </Route>
          <Route path="/account/integrations">
            <Integrations />
          </Route>
        </Switch>
      </div>
    </div>
  );
}
